<div provide-parent-form *ngIf="report">
	<div class="field-group last-is-mat">
		<mat-form-field appearance="fill" class="full-width">
			<mat-label>{{'REPORT_TITLE' | translate}}</mat-label>
			<input [(ngModel)]="report.title " (ngModelChange)="report ? report.title = $event : ''" required type="text" name="report-title" matInput />
		</mat-form-field>
		
		<mat-form-field appearance="fill" class="full-width">
			<mat-label>{{'DESCRIPTION' | translate}}</mat-label>
			<textarea [(ngModel)]="report.description" type="text" name="report-description" matInput></textarea>
		</mat-form-field>
	</div>

	<div class="field-group">
		<h3>{{ 'SELECTION' | translate }} <bb-info [contents]="'HELP.REPORT_FILTERS' | translate"></bb-info></h3>
		
		<div class="selection-wrapper">
			<mat-form-field appearance="fill" class="full-width">
				<mat-label>{{'CLIPS_WITH' | translate}}</mat-label>
				<mat-select [(ngModel)]="report.initialSelection " name="initialSelection">
					<mat-option value="publisheddate">{{ 'PUBLISHED_DATE' | translate }}</mat-option>
					<mat-option value="createddate">{{ 'CREATED_DATE' | translate }}</mat-option>
					<mat-option value="embargo">{{ 'SCHEDULED_AVAILABILITY' | translate }}</mat-option>
					<mat-option value="views">{{ 'VIEWS' | translate }}</mat-option>
				</mat-select>
			</mat-form-field>
			
			<mat-form-field appearance="fill" class="full-width">
				<mat-label>{{'IN' | translate}}</mat-label>
				<mat-select [(ngModel)]="report.dynamicDateRange " name="dynamicDateRange" (ngModelChange)="dateRangePresetChanged($event)">
					<mat-option *ngFor="let preset of dateRangePresets" [value]="preset.value">{{preset.label}}</mat-option>
				</mat-select>
			</mat-form-field>

			<bb-date-presets
				*ngIf="report?.dateRangeType === 'fixed' && fromDate && toDate"
				[minDate]="statsMinDate"
				[startDate]="fromDate"
				[endDate]="toDate"
				preset="custom"
				[hidePresets]="true"
				[useMatFormField]="true" data-cy="reports-date-picker"
				[icon]="'line-chart'" [theme]="'analytics'"
				(onChanged)="onDateRangeSelected($event)"
			></bb-date-presets>
			
			<mat-form-field appearance="fill" class="full-width" *ngIf="report?.dateRangeType === 'dynamic' && ( report.dynamicDateRange === 'last-week' || report.dynamicDateRange === 'week-to-date')">
				<mat-label>{{'FIRST_WEEK_DAY' | translate}}</mat-label>
				<mat-select [(ngModel)]="report.firstWeekDay " name="firstWeekDay">
					<mat-option value="monday">{{ 'MONDAY' | translate }}</mat-option>
					<mat-option value="tuesday">{{ 'TUESDAY' | translate }}</mat-option>
					<mat-option value="wednesday">{{ 'WEDNESDAY' | translate }}</mat-option>
					<mat-option value="thursday">{{ 'THURSDAY' | translate }}</mat-option>
					<mat-option value="friday">{{ 'FRIDAY' | translate }}</mat-option>
					<mat-option value="saturday">{{ 'SATURDAY' | translate }}</mat-option>
					<mat-option value="sunday">{{ 'SUNDAY' | translate }}</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
		

		<bb-filter-set name="filters" [useMatFields]="true" [filterConfig]="filterConfig" [ngModel]="report?.filters " (ngModelChange)="onFilterSetChange($event)"></bb-filter-set>

		<div class="no-results-warning" [class.low-opacity]="searching">
			<span [hidden]="filterSearchResults?.body?.total !== 0" class="warning">
				<i class="fa fa-warning"></i> {{ 'WARNING_FILTERSET_NO_RESULTS' | translate }}
			</span>
		</div>
	</div>

	<div class="field-group">
		<h3>{{ 'COLUMNS' | translate }} <bb-info [contents]="'HELP.REPORT_COLUMNS' | translate"></bb-info></h3>

		<report-columns [(ngModel)]="report" name="report_columns" (ngModelChange)="onColumnsChanged($event)"></report-columns>
	</div>

	<div class="field-group">
		<h3>{{ 'RUN_REPORT' | translate }}</h3>

		<bb-form-element [form]="form" [label]="'GENERATE_NOW_AND_SEND' | translate">
			<bb-button [icon]="'cog'" [disabled]="generatingReport || downloadError || !emailAddress || !report.id || report.id <=0 || form.dirty" (click)="onGenerateDownloadClick($event)">
				<i *ngIf="generatingReport" class="fa fa-download fa-circle-o-notch fa-spin"></i>{{ (generatingReport ? 'GENERATING_REPORT' : 'GENERATE_NOW') | translate }}
			</bb-button>
			<p *ngIf="!report.id || report.id <= 0 || form.dirty">
				<small>{{ 'GENERATE_NOW_AVAILABLE_AFTER_SAVE' | translate }}</small></p>
			<p *ngIf="generatingReport">
				<small>{{ 'HELP.REPORT_BEING_GENERATED' | translate }}</small></p>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'SCHEDULE_TO_EMAIL_REPORT' | translate">
			<bb-button [icon]="'clock-o'" [routerLink]="['../schedule']" (click)="onScheduleClick($event)">
				{{ 'SCHEDULE' | translate }}
			</bb-button>
		</bb-form-element>
	</div>
</div>
